$(".current-price").each(function () {
  var $self = $(this),
    text = $self.text();

  $self.text($.trim(text));
});
